<template>
	<div class="wishlists">
		<h2 class="level-one-heading mb-5">{{ t('MEMBER.WISHLISTS') }}</h2>
		<hr />
		<div class="mb-5">
			Här finner du dina sparade önskelistor, som även kan delas till nära &amp; kära!
		</div>
		<div v-if="selectedWishlist">
			<a-link
				class="back-arrow"
				:to="$router.route({
					name: 'member.wishlists',
					params: Object.assign({}, $route.params, {
						wid: null,
					})
				})"
			>
				Tillbaka
			</a-link>
			<h3 class="mt-4">{{ selectedWishlist.name }}</h3>
			<hr />
			<ul class="cart-list">
				<cart-list-large-row
					v-for="row in selectedWishlist.rows"
					:key="row.id"
					@remove="deleteRow(row, selectedWishlist)"
					:rowHandler="{
						row,
						quantity: row.quantity,
						update: qty => { updateRow(row, qty, selectedWishlist) },
					}"
					:stock="row.product.stock"
					:currency="row.product.price.currency"
				/>
			</ul>
			<hr class="my-5" />
			<div
				v-if="selectedWishlist.rows.length"
				class="add-to-cart-footer"
			>
				<span class="total">
					Totalpris:
					<span class="sum">
						{{ totalPriceFormatted }}
					</span>
				</span>
				<text-button
					:text="t('BUY_BTN.BUY.BIG')"
					size="large"
					@click="addToCart"
				/>
			</div>
			<div v-else class="text-center p-5">
				Listan är tom!
			</div>
			<div class="clearfix" />
			<hr class="my-5">
			<div>
				<modal inline-block>
					<a class="wishlist-action-link" slot="label">
						<span class="glyphicon glyphicon-link" />
						Dela
					</a>
					<share-cart-link-form :cart="selectedWishlist" class="p-5" />
				</modal>
				<!--<a class="wishlist-action-link">
					<span class="glyphicon glyphicon-comment" />
					Skriv kommentar
				</a>-->
				<a class="wishlist-action-link" @click="deleteList(selectedWishlist)">
					<span class="glyphicon glyphicon-trash" />
					Ta bort lista
				</a>
			</div>
		</div>

		<ul v-else-if="wishlists.length" class="list-unstyled">
			<li
				v-for="list in wishlists"
				class="tile"
				:key="list.id"
			>
				<router-link
					:to="$router.route({
						name: 'member.wishlists',
						params: Object.assign({}, $route.params, {
							wid: list.id,
						})
					})"
				>
					<span class="fake-link">{{ list.name }}</span>
					<ximg
						v-for="row in list.rows.slice(0, 11)"
						:key="row.id + '-' + row.product.id"
						:src="row.product.thumbnail"
						:title="row.product.name"
						:ariaLabel="row.product.name"
						role="img"
					/>
					<span class="remove-wishlist">
						{{ list.rows.length || 'Inga' }} {{ list.rows.length === 1 ? 'produkt' : 'produkter' }}
						<icon-button
							variant="delete"
							size="tiny"
							@click.native.prevent="deleteList(list)"
						/>
					</span>
				</router-link>
			</li>
		</ul>
		<div v-else>
			Du har inga önskelistor!
		</div>
	</div>
</template>

<script>
import waja from 'waja';
import alert from 'alert';
import bus from 'eventbus';
import store from 'datastore';
import { t } from 'datastore/i18n';
import { formatPrice, inStockAnywhere } from 'utils';
import { mapGetters } from 'vuex';
import mq, { isDesktop } from 'mediaQuery';

export default {
	store,
	data () {
		return {
			wishlists: [],
			mq,
		};
	},
	beforeRouteEnter (to, frm, next) {
		// @TODO if there is no wishlist id in the route,
		// då kanske det är en annan användares wishlist
		waja.get('wishlist')
			.on('success', res => {
				if (store.state.user.id !== parseInt(to.params.id)) {
					next(`/se/member/${to.params.id}/achievements`);
				} else {
					next(vm => {
						vm.wishlists = res.data.wishlists;
					});
				}
			}).on('error', err => {
				next(`/se/member/${to.params.id}/achievements`);
			}).go(); // @TODO 401 not authenticated
	},
	methods: {
		t,
		addToCart () {
			// @TODO BUY BUTTON CONDITIONS!!!!
			const products = [];
			const cartProducts = store.state.cart.rows.map(item => item.product.id);
			for (const row of this.selectedWishlist.rows) {
				const hasValue = cartProducts.some(el => el === row.product.id);
				const inStock = inStockAnywhere(row.product.stock);
				const fullyBooked = row.product.statusCodes && row.product.statusCodes.indexOf(9/* Tillfälligt fullbokad*/) >= 0;

				if (! hasValue && (! row.product.discontinued || inStock) && ! fullyBooked) {
					products.push({ product: row.product, amount: row.quantity });
				} else if (hasValue) {
					alert('Du har redan denna vara i varukorgen.');
				} else if (fullyBooked) {
					alert('En vara du försökt lägga i varukorgen är tillfälligt fullbokad.');
				}
			}
			if (products.length) {
				const trackingData = {
					event: 'addToCart',
					source: this.$route.name,
					stock: this.mq.current > this.mq.sm,
					coupon: true,
				};

				this.$store.dispatch('cart/addMany', {
					products: products,
					trackingData: trackingData,
				});
			}
		},
		updateRow (row, quantity, list) {
			if (quantity === row.quantity) {
				console.log('updateRow: no changes detected, aborting');
				return;
			}
			waja.patch('wishlist/' + list.id + '/' + row.id)
				.data({
					quantity,
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE',
				})
				.on('success', res => {
					row.quantity = quantity;
				}).go();
		},
		deleteList (list) {
			bus.$emit('modal.confirm', 'Är du säker på att du vill ta bort listan "' + list.name + '"?', () => {
				waja.delete('wishlist/' + list.id)
				.data({
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE'
				})
				.on('success', res => {
					// @TODO if list is selected wishlist, change route
					const index = this.wishlists.indexOf(list);
					if (index >= 0) {
						this.wishlists.splice(index, 1);
					}
					alert('Listan har tagits bort!');
				}).go();
			});
		},
		deleteRow (row, list) {
			waja.delete('wishlist/' + list.id + '/' + row.id)
				.data({
					touchpoint: isDesktop() ? 'DESKTOP' : 'MOBILE'
				})
				.on('success', res => {
					const index = list.rows.indexOf(row);
					if (index >= 0) {
						list.rows.splice(index, 1);
					}
				}).go();
		},
	},
	computed: {
		totalPriceFormatted () {
			if (! this.selectedWishlist || ! this.selectedWishlist.rows.length) {
				return 0;
			}
			let currency = null;
			let totalPrice = 0;
			for (const row of this.selectedWishlist.rows) {
				const inStock = inStockAnywhere(row.product.stock);
				const fullyBooked = row.product.statusCodes && row.product.statusCodes.indexOf(9/* Tillfälligt fullbokad*/) >= 0;

				if ((! row.product.discontinued || inStock) && ! fullyBooked) {
					const price = row.product.price;
					totalPrice += price.price * row.quantity;
					currency = price.currency;
				}
			}
			return formatPrice(totalPrice, currency);
		},
		selectedWishlist () {
			const wId = ~~this.$route.params.wid;
			if (! wId) {
				return null;
			}
			for (const list of this.wishlists) {
				if (list.id === wId) {
					return list;
				}
			}
			return null;
		},
		...mapGetters({
			isLoggedIn: 'user/isLoggedIn',
		}),
	},
};
</script>
